export default "__VITE_ASSET__C75ba5et__"